import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import {
  getRecentlyViewed,
  type RecentlyViewedItem,
} from "@/lib/recently-viewed";

export default function RecentlyViewed() {
  const [recentProperties, setRecentProperties] = useState<
    RecentlyViewedItem[]
  >([]);

  useEffect(() => {
    setRecentProperties(getRecentlyViewed());
  }, []);

  if (recentProperties.length === 0) {
    return null;
  }

  return (
    <section>
      <h2 className="text-2xl font-bold mb-6">Recently Viewed</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {recentProperties.map((property) => (
          <Card key={property.id} className="overflow-hidden">
            <div className="relative h-40 w-full">
              <img
                src={property.image || "/placeholder.svg"}
                alt={property.title}
                className="object-cover w-full h-full"
              />
            </div>
            <CardContent className="p-4">
              <h3 className="font-semibold">{property.title}</h3>
              <div className="flex items-center text-muted-foreground mt-1">
                <MapPin className="h-4 w-4 mr-1" />
                <span className="text-sm">{property.address}</span>
              </div>
              <div className="flex justify-between items-center mt-4">
                <div className="font-bold">
                  ₦
                  {new Intl.NumberFormat("en-NG", {
                    maximumFractionDigits: 0,
                  }).format(property.rent)}
                  /mo
                </div>
                <Link to={`/properties/${property.id}`}>
                  <Button variant="outline" size="sm">
                    View Again
                  </Button>
                </Link>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
}
